import { Injectable } from '@angular/core';
import { Request, XHRBackend, RequestOptions, Response, Http, RequestOptionsArgs, Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/retryWhen';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { IReturnObject } from './shared/return-object.model';
// import { SessionExpiredModal } from './login/session-expired-modal.component';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AppConfig } from './config/app.config';

@Injectable()
export class GlobalHttpHandler extends Http {

    closedSubjects: Array<Subject<any>>;
    showWamLogin: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(backend: XHRBackend, defaultOptions: RequestOptions, private config: AppConfig) {
        super(backend, defaultOptions);
        this.closedSubjects = [];
    }

    public request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        const closedSubject = new Subject();
        return super.request(url, options).retryWhen((err) => this.errorHandler(err, url, closedSubject));
    }

    private errorHandler(errors: any, url: string | Request, closedSubject: Subject<any>): any {
        const closedSubjects = this.closedSubjects;

        return errors.switchMap((err: Response) => {
            if (err.status === 0 && (window.location.href.match(/\?/g) || []).length < 2) {
              console.log('The authenticated session expired or the user is not authorized. Logging in again.', errors);

              alert("Your application session is expired. You will be logged-in again and redirected to home page.");

              //window.location.replace('https://wam-ext-atst.scania.com/pkmslogout?targeturl=http://localhost:55556/#/');
              window.location.replace(`${this.config.get('apiUrl')}AccessControl/PerformSSO`);

              this.showWamLogin.next(true);
                if (closedSubjects.indexOf(closedSubject) < 0) {
                    closedSubjects.push(closedSubject);
                    return <any>closedSubject;
                }
                return new Subject();
            }


            console.log('Throwing error...', err);
            return Observable.throw(err);
        });
    }

    public userLoggedIn() {
        this.showWamLogin.next(false);
        this.closedSubjects.forEach((closedSubject, index, array) => {
            closedSubject.next('finished');
            setTimeout(() => {
                array.splice(index, 1);
          }, 3240000);//1000
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/global-http-handler.ts